'use strict';
module.exports = function(app) {
    app.controller('slideShowController', ['$scope', 'socket', 'syncDisPlayProductFactory', 'FrontEndService', function($scope, socket, syncDisPlayProductFactory, FrontEndService) {
        function successGetProducts(response) {
            $scope.displayProduct = syncDisPlayProductFactory.getStartedProduct(response);
        }

        FrontEndService.url().then(function onSuccess(response) {
          if (response.status === 200) {
               $scope.img_url = response.data.product_images_url;
           }
        });

        socket.on('update:products', successGetProducts);
        socket.emit('get:model');
    }]);
};



/*****************
 ** WEBPACK FOOTER
 ** ./slide_show/js/controller/slide_show.controller.js
 ** module id = 61
 ** module chunks = 0
 **/